
import React from 'react';
import AppLayout from '@/components/layout/AppLayout';
import TrialConfirmation from '@/components/application/TrialConfirmation';
import ApplicationStepper from '@/components/application/ApplicationStepper';

const TrialPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4">
        <ApplicationStepper />
        <h1 className="text-2xl font-bold mb-2 text-jungle text-center md:text-2xl">
          Trial Blocks
        </h1>
        <p className="text-gray-600 mb-8 text-center">
          You're ready to start your trial block with HIVED
        </p>
        <TrialConfirmation />
      </div>
    </AppLayout>
  );
};

export default TrialPage;
